import store from './store';
import permissions from './permissions';

function requireGuest(to, from, next) {

  if (store.getters['user/authenticated']) {
    if (window.IS_CORDOVA) {
      next({name: 'meal-entries'});
    } else {
      next({name: 'profile'});
    }
  } else {
    if (store.getters['user/user']) {
      store.dispatch('user/checkin').then(() => {
        if (store.getters['user/authenticated']) {
          if (window.IS_CORDOVA) {
            next({name: 'meal-entries'});
          } else {
            next({name: 'profile'});
          }
        } else {
          next();
        }
      }).catch(() => {
        next();
      });
    } else {
      next();
    }
  }
}

function requireAuth(to, from, next) {

  if (store.getters['user/authenticated']) {
    passPermissions(to, from, next);
  } else {
    if (store.getters['user/user']) {
      store.dispatch('user/checkin').then(() => {
        if (store.getters['user/authenticated']) {
          passPermissions(to, from, next);
        } else {
          next({name: 'login'});
        }
      }).catch(() => {
        next({name: 'login'});
      });
    } else {
      next({name: 'login'});
    }
  }
}

function passPermissions(to, from, next) {
  if (to.meta.permission) {

    if (permissions.can(to.meta.permission)) {
      next();
    } else {
      next({name: 'profile'});
      store.dispatch('notifications/setError', 'You are unauthorized to perform that action');
    }
  } else {
    next();
  }
}

// Export middleware
export {requireGuest, requireAuth };
